export const isValidBirthday = (day: number, month: number, year: number): boolean => {
  const currentYear = new Date().getFullYear();

  if (year < 1900 || year > currentYear) {
    return false;
  }
  if (month < 1 || month > 12) {
    return false;
  }
  if (day < 1 || day > 31) {
    return false;
  }

  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
};

export const formatBirthday = (day: string, month: string, year: string) => {
  return new Date(`${year}-${month}-${day}`).toISOString().slice(0, 10);
};

export const parseBirthday = (birthday: string) => {
  const [year, month, day] = birthday.split('-');
  return { day, month, year };
};

export const parseDate = (date?: Date) => {
  if (!date) return { day: '', month: '', year: '' };

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString();

  return { day, month, year };
};
